
export const MLB_SITE_ID = "mlb-wine-brands";
export const SBG_SITE_ID = "sbg";
export const TAKE_FIVE_ID = "takefive";
export const BEER_CAN_CHICKEN_ID = "beercanchicken";
export const HORMEL_SITE_ID = "hormel";
export const THE_MAKERS_BARN = "the-makers-barn";
export const GOODFRIENDS = "goodfriends";
export const DRINKAMIE = "drinkamie";
export const TEQUILA_ZERO = "tequila-zero";